const projectAnim = {
  isMobileOrTablet() {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      ) || navigator.maxTouchPoints > 2
    );
  },

  currentImageIndex: 0,

  createLightbox() {
    const lightbox = document.createElement("div");
    lightbox.className = "lightbox";
    lightbox.innerHTML = `
      <div class="lightbox-content">
        <button class="lightbox-close">&times;</button>
        <button class="lightbox-prev">&#10094;</button>
        <img class="lightbox-image" src="" alt="">
        <button class="lightbox-next">&#10095;</button>
      </div>
    `;
    document.body.appendChild(lightbox);
    return lightbox;
  },

  openLightbox(images, index) {
    const lightbox =
      document.querySelector(".lightbox") || this.createLightbox();
    const image = lightbox.querySelector(".lightbox-image");
    const prevBtn = lightbox.querySelector(".lightbox-prev");
    const nextBtn = lightbox.querySelector(".lightbox-next");
    const closeBtn = lightbox.querySelector(".lightbox-close");

    this.currentImageIndex = index;

    const updateImage = () => {
      image.src = images[this.currentImageIndex].src;
    };

    updateImage();
    lightbox.classList.add("active");

    // Animation d'ouverture GSAP
    gsap.fromTo(
      lightbox,
      { opacity: 0 },
      { opacity: 1, duration: 0.4, ease: "power2.out" },
    );
    gsap.fromTo(
      lightbox.querySelector(".lightbox-content"),
      { scale: 0.8, opacity: 0 },
      { scale: 1, opacity: 1, duration: 0.5, ease: "back.out" },
    );

    prevBtn.onclick = () => {
      this.currentImageIndex =
        (this.currentImageIndex - 1 + images.length) % images.length;
      updateImage();
    };

    nextBtn.onclick = () => {
      this.currentImageIndex = (this.currentImageIndex + 1) % images.length;
      updateImage();
    };

    closeBtn.onclick = () => lightbox.classList.remove("active");
    lightbox.onclick = (e) => {
      if (e.target === lightbox) lightbox.classList.remove("active");
    };
  },

  init() {
    document.addEventListener("DOMContentLoaded", () => {
      const isMobileOrTablet = this.isMobileOrTablet();
      const cursor = document.querySelector(".blob-agence");
      const imageWrappers = document.querySelectorAll(".image-wrapper");
      const images = Array.from(imageWrappers).map(
        (w) => w.querySelector("img") || w.querySelector("iframe"),
      );
      const buttonBack = document.querySelector("#gobackbutton span");

      /* Bouton RETOUR */

      if (history.length <= 1) {
        buttonBack.innerHTML = "Voir toutes les réalisations ";

        buttonBack.addEventListener("click", () => {
          window.location = "/realisations";
        });
      } else {
        buttonBack.addEventListener("click", () => {
          history.back();
        });
      }

      /* GSAP ANIMATIONS */
      //Smooth content
      let smoother = ScrollSmoother.create({
        wrapper: "#smooth-container",
        content: "#smooth-content",
        smooth: 0.7,
        effects: false,
      });

      /* sticky details */

      if (!isMobileOrTablet){
      gsap.to(".project-details", {
        scrollTrigger: {
          trigger: ".project-details",
          start: "0% 0%",
          /* end: "top center", */
          pin: true,
          markers: false,
          end: "bottom bottom",
        },
        x: 0,
      });
    }

      /* effect on images */

      if (!isMobileOrTablet) {
        imageWrappers.forEach((wrapper, index) => {
          wrapper.addEventListener("mouseenter", () => {
            cursor.style.opacity = "0";
          });

          wrapper.addEventListener("mouseleave", () => {
            cursor.style.opacity = "1";
          });

          wrapper.addEventListener("click", () => {
            this.openLightbox(images, index);
          });
        });

        document.addEventListener("mousemove", (e) => {
          // Update cursor position
          gsap.to(cursor, {
            x: e.clientX - 25,
            y: e.clientY - 25,
            duration: 0.5,
            ease: "power2.out",
          });

          // Update glass position on all wrappers (important for iframes)
          imageWrappers.forEach((wrapper) => {
            const rect = wrapper.getBoundingClientRect();
            const glass = wrapper.querySelector(".glass");

            // Check if cursor is over this wrapper
            const isOverWrapper =
              e.clientX >= rect.left &&
              e.clientX <= rect.right &&
              e.clientY >= rect.top &&
              e.clientY <= rect.bottom;

            if (glass && isOverWrapper) {
              const x = e.clientX - rect.left;
              const y = e.clientY - rect.top;
              glass.style.transform = `translate(${x - 40}px, ${y - 40}px)`;
            }
          });
        });
      }

      // SCROLL TO TOP BUTTON
      const scrollToTopBtn = document.getElementById("scroll-to-top");
      if (scrollToTopBtn) {
        window.addEventListener("scroll", () => {
          if (window.scrollY > 300) {
            scrollToTopBtn.classList.add("visible");
          } else {
            scrollToTopBtn.classList.remove("visible");
          }
        });

        scrollToTopBtn.addEventListener("click", () => {
          ScrollSmoother.get().scrollTo(0, true);
        });
      }
    });
  },
};

export default projectAnim;
